import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

import { signOut } from '../../store/actions';

class Logout extends Component {
    componentDidMount () {
        this.props.onLogout();
    }

    render () {
        return <Redirect to="/login"/>;
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onLogout: () => dispatch( signOut() )
    };
};

export default connect(null, mapDispatchToProps)(Logout);


// WEBPACK FOOTER //
// ./src/components/Logout/Logout.js